import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectConfigs } from "@app/configs/configsSlice";
import { setPlayerType } from "@app/channels/channelsSlice";
import { getApps } from "@server/requests";
import LOCAL_STORAGE from "@utils/localStorage";
import { isLauncherEnabled } from "@platform/index";
// import TimeWrapper from "@components/splash-screen/TimeWrapper";
import NetworkStatus from "@components/splash-screen/NetworkStatus";
import MenuItems from "@components/menu/MenuItems";
import LogoutModal from "@components/modals/LogoutModal";
import "@styles/components/menu.scss";
import AppLogo from "@components/common/AppLogo";

export default function Menu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const configs = useSelector(selectConfigs);
  const [apps, setApps] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Check if launcher functionality is enabled
  const launcherEnabled = isLauncherEnabled();

  const getAppsHandler = async () => {
    // Only fetch apps if launcher functionality is enabled
    if (!launcherEnabled) {
      console.log("Launcher functionality disabled, skipping apps fetch");
      return;
    }

    try {
      const res = await getApps({
        device_id: LOCAL_STORAGE.MAC_ADDRESS.GET(),
      });
      const parsedRes = JSON.parse(res);
      if (!parsedRes.error) {
        const filteredApps = parsedRes.message.filter((app) => !app.visible);
        setApps(filteredApps);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowLogoutModal = () => {
    setShowLogoutModal(true);
  };

  useEffect(() => {
    dispatch(setPlayerType("live"));
    localStorage.removeItem("lastIndex");
    localStorage.removeItem("lastRow");

    // Only fetch apps if launcher is enabled
    if (launcherEnabled) {
      getAppsHandler();
    }
  }, [launcherEnabled]);

  return (
    <div className="menu-wrapper">
      <div className="head-menu-wrapper">
        {/* <TimeWrapper /> */}
        <AppLogo />
        <NetworkStatus />
      </div>
      <MenuItems
        apps={apps}
        isLauncher={launcherEnabled}
        onShowLogoutModal={handleShowLogoutModal}
        isLogoutModalOpen={showLogoutModal}
      />

      <LogoutModal
        isVisible={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </div>
  );
}
